import { createAction } from 'redux-actions'
import { Alert } from 'types/alert'

export const FETCH_ADD_ALERT = 'FETCH_ADD_ALERT'
export const addAlert = createAction<Alert>(FETCH_ADD_ALERT)

export const REMOVE_ALERT = 'REMOVE_ALERT'
export const removeAlert = createAction<Alert>(REMOVE_ALERT)
